import type { Ni18nOptions } from 'ni18n';
import { Languages } from './src/model/types';

export const defaultLocale = Languages.EN;

export const supportedLngs = Object.keys(Languages).map((key) => key);

export const ni18nConfig: Ni18nOptions = {
    /**
     * Set `fallbackLng` to the `supportedLngs` array in order for them all to be loaded
     */
    fallbackLng: supportedLngs,
    supportedLngs,
    ns: [
        'agentStatus',
        'common',
        'customers',
        'dashboard',
        'emailVerify',
        'error',
        'filters',
        'forgotPassword',
        'forms',
        'login',
        'loginPage',
        'organizations',
        'people',
        'rating',
        'register',
        'resetPassword',
        'seo',
        'tables',
        'tickets',
        'reports',
        'admin',
        'subscription'
    ],
    react: {
        useSuspense: false
    },
    returnEmptyString: true
};
